import React, { CSSProperties, ReactNode } from 'react'

interface IProps {
  label: string
  children: ReactNode
  dark?: boolean
  strong?: boolean
  rf?: string
  mainClass?: string
  style?: CSSProperties
}

const ResultRow = ({ label, children, dark, strong, rf, style, mainClass }: IProps) => {
  const rowClass = !dark ? 'csas-result csas-low-result' : 'csas-result csas-result-dark'

  const strongClass = strong ? 'csas-strong-medium' : 'csas-strong-small'

  return (
    <div className={rowClass + ' ' + mainClass} style={style} data-testid='result-row'>
      <div className='csas-result-inner'>
        <div className='csas-result-inner-left' data-testid='result-row-label'>
          {label}
        </div>
        <div className='csas-result-inner-right'>
          <strong className={strongClass} data-testid={rf}>
            {children}
          </strong>
        </div>
      </div>
    </div>
  )
}

export default ResultRow
